import React, { useEffect } from 'react';
import { useEditor, EditorContent } from '@tiptap/react';
import { buildSopExtensions } from './tiptap/sopExtensions';
import { EMPTY_DOC } from './tiptap/sopJson';
import { flattenStepContent } from '../../utils/sopContent';
import './sop-tiptap.css';

/**
 * Read-only SOP renderer. Older step-format docs are flattened to the plain
 * shape on the way in.
 */
const SopRichView = ({ value, darkMode = false }) => {
  const editor = useEditor(
    {
      extensions: buildSopExtensions({ mode: 'view' }),
      content: flattenStepContent(value || EMPTY_DOC),
      editable: false,
    },
    []
  );

  useEffect(() => {
    if (!editor) return;
    const incoming = flattenStepContent(value || EMPTY_DOC);
    if (JSON.stringify(editor.getJSON()) === JSON.stringify(incoming)) return;
    editor.commands.setContent(incoming, false);
  }, [value, editor]);

  return (
    <div className={`sop-view${darkMode ? ' sop-dark' : ''}`}>
      <EditorContent editor={editor} />
    </div>
  );
};

export default SopRichView;
